module.exports = __webpack_public_path__ + "img/file-type-code-alt.5ef76535.svg";